import React from 'react'
import { Price, Body, Button, HorizontalSpacer, Icon, Hide, Message, Link } from '@superhi/design'

import { RECURRING_INTERVAL, useGetPrice } from '../../../../utils'

import { Wrapper, DiscountsText } from './styles'

import { DASHBOARD_URL } from 'src/config'
import { useSession } from 'src/api'
import { buildPath } from 'src/routing'

const CHECKOUT_PATH = buildPath('membership-product-checkout')

type Level = '1' | '2'

const BODY_LEVEL: Record<Level, React.ComponentProps<typeof Body>['level']> = {
  '1': '2',
  '2': '3',
}

type Props = {
  level?: Level
}

const JoinNowInfo: React.FC<React.PropsWithChildren<Props>> = ({ level = '1' }) => {
  const price = useGetPrice()

  const [_, __, { hasActiveMembership }] = useSession()

  if (hasActiveMembership) {
    return (
      <Message color="YELLOW_20" level="2">
        <span>You already have a membership —</span>{' '}
        <Link href={DASHBOARD_URL} isExternal>
          dive straight in!
        </Link>
      </Message>
    )
  }

  if (!price) {
    return (
      <Button level="1" disabled>
        Loading...
      </Button>
    )
  }

  return (
    <Wrapper>
      {price.userDiscount && (
        <DiscountsText>
          {!hasActiveMembership && price.userDiscount && (
            <HorizontalSpacer amount={{ small: 4, medium: 6, large: 8 }}>
              <Hide at={['small']}>
                <Icon name="shape-wedge" color="BLUE_50" />
              </Hide>
              <Body color="BLUE_50" level={BODY_LEVEL[level]}>
                Extra discount for {price.userDiscount.durationTextTone}*
              </Body>
            </HorizontalSpacer>
          )}
        </DiscountsText>
      )}

      <Button level="1" href={CHECKOUT_PATH} disabled={hasActiveMembership}>
        {hasActiveMembership ? (
          'You already have a membership'
        ) : (
          <>
            <span>Join for </span>
            {price.display}
            <span>{price.recurring ? `/${RECURRING_INTERVAL[price.recurring.interval]}` : ''}</span>
          </>
        )}
      </Button>

      {!hasActiveMembership && price?.nextPriceIsDifferent && price.userDiscount && (
        <Body level="3">
          <span>*After </span>
          {price.userDiscount.durationTextTone}
          <span> the cost will be </span>
          <Price currencyCode={price.currencyCode}>{price.nextPrice}</Price>
          <span>{price.recurring ? `/${RECURRING_INTERVAL[price.recurring.interval]}` : ''}</span>
        </Body>
      )}
    </Wrapper>
  )
}

export default JoinNowInfo
